export default closeDate => {
  if (!closeDate) return false;
  return new Date(closeDate) < new Date();
};
